/**
 * The landing page's sections, shared by the top nav and the footer so the two
 * never drift apart.
 *
 * Real routes rather than hash fragments: the same links render on /login and
 * /signup, and a path like `/features` works from anywhere.
 */
export const SITE_SECTIONS = [
  { label: "How it works", href: "/how-it-works" },
  { label: "What you get", href: "/features" },
  { label: "Questions", href: "/faq" },
];
